import PropTypes from "prop-types";
import TripRecordCard from "./TripRecordCard";

const PhotosAndRecordsPanel = ({ resDetails, t }) => (
    <div className="rounded-2xl border border-[#f0f0f0] bg-white p-4 lg:p-5">
        <h2 className="fontSemi mb-4 text-base text-[#2F2F46]">{t("upcomingDetails.customersRecord")}</h2>

        <div className="grid gap-3 lg:grid-cols-2">
            <TripRecordCard
                title={t("upcomingDetails.tripRecords.checkInRecord")}
                timestamp={resDetails?.exactPickupTime || resDetails?.pickupDate}
                record={resDetails?.checkIn}
                t={t}
            />
            <TripRecordCard
                title={t("upcomingDetails.tripRecords.checkOutRecord")}
                timestamp={resDetails?.exactDropoffTime || resDetails?.dropoffDate}
                record={resDetails?.checkOut}
                t={t}
            />
        </div>
    </div>
);

PhotosAndRecordsPanel.propTypes = {
    resDetails: PropTypes.object,
    t: PropTypes.func.isRequired,
};

export default PhotosAndRecordsPanel;
